import {
  appendToUrl
} from './services/utils';
import Product from './product';
import Callout from './components/callout';

class cart {
  constructor() {
    this.errorWrapper = $('.cart-error-wrapper');
    this.couponErrorWrapper = $('.coupon-error-wrapper');
  }

  run() {
    this.remove();
    this.shippingMethods();
    this.coupon();
    this.quantity();
    this.qtyInput();
    this.boxToggle();
    this.emptyCart();
  }

  boxToggle() {
    $('.box-toggle').click((e) => {
      $(e.currentTarget).toggleClass('closed');
      $(e.currentTarget).siblings('.box-body').stop().slideToggle(450, 'easeInOutCirc');
    });
  }

  shippingMethods() {
    $('.shippingMethods').change((e) => {
      var url = $(e.currentTarget).attr('data-actionUrl');

      var urlParams = {
        methodID: $(e.currentTarget).find(':selected').attr(
          'data-shipping-id'
        )
      };

      // $('.totals').spinner().start();

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams,
        success: (data) => {
          if (data.error) {
            window.location.href = data.redirectUrl;
          } else {
            $('.coupons-and-promos').empty().append(data.totals
              .discountsHtml);
            this.updateCartTotals(data);
            this.updateApproachingDiscounts(data.approachingDiscounts);
            this.validateBasket(data);
            this.updateScalapayTotal(data);
          }
          // $.spinner().stop();
        },
        error: (err) => {
          if (err.redirectUrl) {
            window.location.href = err.redirectUrl;
          } else {
            // createErrorNotification(err.responseJSON.errorMessage);
            // $.spinner().stop();
          }
        }
      });
    });
  }

  coupon() {
    $('.promo-code-form').submit((e) => {
      e.preventDefault();
      // $.spinner().start();

      $('.coupon-missing-error').hide();
      $('.coupon-error-message').empty();

      if (!$('.coupon-code-field').val()) {
        $('.promo-code-form .form-control').addClass('is-invalid');
        $('.coupon-missing-error').show();
        // $.spinner().stop();
        return false;
      }

      var $form = $('.promo-code-form');
      $('.promo-code-form .form-control').removeClass('is-invalid');
      $('.coupon-error-message').empty();

      $.ajax({
        url: $form.attr('action'),
        type: 'GET',
        dataType: 'json',
        data: $form.serialize(),
        success: (data) => {
          if (data.error) {
            $('.coupon-error-wrapper').show();
            $('.promo-code-form').find('[for="couponCode"]').addClass('is-invalid-label').removeClass('is-valid-label');
            $('.promo-code-form').find('input[name="couponCode"]').addClass('is-invalid-input').removeClass('is-valid-input');
            $('.promo-code-form .form-control').addClass(
              'is-invalid'
            );
            $('.coupon-error-message').empty().append(data.errorMessage);
            Callout.error(null, data.errorMessage, this.couponErrorWrapper);
          } else {
            $('.coupon-error-wrapper').hide();
            $('.promo-code-form').find('[for="couponCode"]').removeClass('is-valid-label').removeClass('is-invalid-label');
            $('.promo-code-form').find('input[name="couponCode"]').removeClass('is-valid-input').removeClass('is-invalid-input');
            $('.coupons-and-promos').empty().append(data.totals
              .discountsHtml);
            this.updateCartTotals(data);
            this.updateScalapayTotal(data);
            this.updateApproachingDiscounts(data.approachingDiscounts);
            this.validateBasket(data);
            $(document).find('.remove-coupon').data('action', data.actionUrls.removeCouponLineItem);
          }
          $('.coupon-code-field').val('');
          // $.spinner().stop();
        },
        error: (err) => {
          $('.coupon-error-wrapper').show();
          $('.promo-code-form').find('[for="couponCode"]').addClass('is-invalid-label').removeClass('is-valid-label');
          $('.promo-code-form').find('input[name="couponCode"]').addClass('is-invalid-input').removeClass('is-valid-input');
          $('.promo-code-form .form-control').addClass(
              'is-invalid'
          );
          $('.coupon-error-message').empty().append(err.errorMessage);
          Callout.error(null, $form.data('error'), $form.find('.coupon-error-wrapper'));
        }
      });
      return false;
    });

    $('body').on('click', '.remove-coupon', (e) => {
      e.preventDefault();

      const actionUrl = $(e.currentTarget).data('action');
      const couponCode = $(e.currentTarget).data('code');
      const uuid = $(e.currentTarget).data('uuid');
      // const $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
      // const $productToRemoveSpan = $('.coupon-to-remove');

      var removePopup = new Foundation.Reveal($(`#removeCouponModal-${uuid}`));
      removePopup.open();

      this.removeCoupon(actionUrl, couponCode, uuid);
    });
  }

  removeCoupon(actionUrl, couponCode, uuid) {
    $(`#removeCouponModal-${uuid} .delete-coupon-confirmation-btn`).on('click', (e) => {
      e.preventDefault();

      const url = appendToUrl(actionUrl, {
        code: couponCode,
        uuid: uuid
      });

      // $('body > .modal-backdrop').remove();
      // $.spinner().start();

      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: (data) => {
          $('.coupon-uuid-' + uuid).remove();
          this.updateCartTotals(data);
          this.updateScalapayTotal(data);
          this.updateApproachingDiscounts(data.approachingDiscounts);
          this.validateBasket(data);
          // $.spinner().stop();
        },
        error: (err) => {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            // createErrorNotification(err.responseJSON.errorMessage);
            // $.spinner().stop();
          }
        }
      });
    });
  }

  onHold() {
    $('.optional-promo').click((e) => {
      e.preventDefault();
      $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
      $.spinner().start();
      $.ajax({
        url: $(this).data('url'),
        method: 'GET',
        dataType: 'json',
        success: function (data) {
          Product.methods.editBonusProducts(data);
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });

    Product.selectAttribute();
    Product.colorAttribute();
    Product.removeBonusProduct();
    Product.selectBonusProduct();
    Product.enableBonusProductSelection();
    Product.showMoreBonusProducts();
    Product.addBonusProductsToCart();
  }

  quantity() {
    $('.quantity-form .quantity').on('change', (e) => {
      const preSelectQty = $(e.currentTarget).data('pre-select-qty');
      const quantity = $(e.currentTarget).val();
      const productID = $(e.currentTarget).data('pid');
      let url = $(e.currentTarget).data('action');
      const uuid = $(e.currentTarget).data('uuid');
      const maxQuantity = parseInt($(e.currentTarget).data('maxqty'), 10);

      if (quantity > maxQuantity || quantity <= 0) {
        return null;
      }

      var urlParams = {
        pid: productID,
        quantity: quantity,
        uuid: uuid
      };
      url = appendToUrl(url, urlParams);

      // $(this).parents('.card').spinner().start();

      $.ajax({
        url: url,
        type: 'get',
        context: this,
        dataType: 'json',
        success: (data) => {
          $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
          $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
          this.updateCartTotals(data);
          this.updateScalapayTotal(data);
          this.updateApproachingDiscounts(data.approachingDiscounts);
          this.updateAvailability(data, uuid);
          this.validateBasket(data);
          handleShippingLabel(data);
          $(this).data('pre-select-qty', quantity);
          // $.spinner().stop();
          if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
            location.reload();
          }
          // DataLayer remove
          var qLineItem = basketJson[productID][0].quantity;
          // La singola aggiunta è sempre di un'unità
          basketJson[productID][0].quantity = 1;
          if (parseInt(qLineItem) < parseInt(quantity)) {
            dataLayer.push({
              where: pageTypeForJS,
              event: 'add_to_cart',
              ecommerce: Product.getDataLayerGA4(data, productID, "add_to_cart", true)
            });
            dataLayer.push({
              where: pageTypeForJS,
              event: 'update_cart',
              ecommerce: Product.getCartGA4Model(data, "update_cart", false)
            });
          } else if (parseInt(qLineItem) > parseInt(quantity)) {
            dataLayer.push({
              event: 'remove_from_cart',
              ecommerce: Product.getDataLayerGA4(data, productID, "remove_from_cart", true)
            });
            dataLayer.push({
              where: pageTypeForJS,
              event: 'update_cart',
              ecommerce: Product.getCartGA4Model(data, "update_cart", false)
            });
          }
          // aggiorno per gli eventi successivi
          basketJson[productID][0].quantity = quantity;
        },
        error: (err) => {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            // createErrorNotification(err.responseJSON.errorMessage);
            $(this).val(parseInt(preSelectQty, 10));
            // $.spinner().stop();
          }
        }
      });
    });
  }

  emptyCart() {
    $('#cart .js-empty-cart-trigger').click((e) => {
      e.preventDefault();
      const modalid = $(e.currentTarget).data('open');

      var modal = new Foundation.Reveal($(`#${modalid}`));
      modal.open();
    });
  }

  remove() {
    $('#cart .remove-cart-product').click((e) => {
      e.preventDefault();

      const actionUrl = $(e.currentTarget).data('action');
      const productID = $(e.currentTarget).data('pid');
      const productName = $(e.currentTarget).data('name');
      const uuid = $(e.currentTarget).data('uuid');

      var removePopup = new Foundation.Reveal($(`#removeProductModal-${uuid}`));
      removePopup.open();

      this.removeProduct(actionUrl, productID, productName, uuid);
    });
  }

  removeProduct(actionUrl, productID, productName, uuid) {
    $(`#removeProductModal-${uuid} .cart-delete-confirmation-btn`).off('click').on('click', (e) => {
      e.preventDefault();

      const url = appendToUrl(actionUrl, {
        pid: productID,
        uuid: uuid
      });

      // $.spinner().start();

      $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: (data) => {
          if (data.basket.items.length === 0) {
            location.reload();
            // $('.empty-cart-wrapper').empty().append(
            //     `<div class="cart-empty text-center"><h1>${data.basket.resources.emptyCartMsg}</h1></div>`
            // );
            // $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
            // $('.minicart-quantity').empty().append(data.basket.numItems);
            // $('.cart-page, .cart-bottom-totals, .bottom-checkout, .cart-sidebar').remove();
            // $('.cart-main-content').removeClass('large-8');
          } else {
            if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length
                            > 0) {
              for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
              }
            }

            $('.uuid-' + uuid).remove();
            if (!data.basket.hasBonusProduct) {
              $('.bonus-product').remove();
            }
            $('.coupons-and-promos').empty().append(data.basket
              .totals.discountsHtml);

            this.updateCartTotals(data.basket);
            this.updateScalapayTotal(data.basket);
            this.updateApproachingDiscounts(data.basket.approachingDiscounts);
            this.validateBasket(data.basket);
          }
          dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: Product.getDataLayerGA4(
              data.basket,
              data.removedItemModel,
              "remove_from_cart",
              false
            )
          });

          dataLayer.push({
            event: 'update_cart',
            ecommerce: Product.getCartGA4Model(
                data.basket,
                "update_cart",
                false
            )
          });
        },
        error: (err) => {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            Callout.error(null, err.responseJSON.errorMessage,
              this.errorWrapper);
          }
        }
      });
    });
  }

  qtyInput() {
    $(document).ready(() => {
      $('.quantity-input').each((i, el) => {
        const incBtn = $('.increase', el);
        const decBtn = $('.decrease', el);
        const qtyInput = $('.quantity', el);
        const max = parseInt(qtyInput.data('maxqty'), 10);
        let qty = parseInt(qtyInput.val(), 10);

        if (qty === max) {
          $(incBtn).css('cursor', 'default');
        }

        if (qty === 1) {
          $(decBtn).css('cursor', 'default');
        }
      });
    });

    $('.quantity-input').each((i, el) => {
      const incBtn = $('.increase', el);
      const decBtn = $('.decrease', el);
      const qtyInput = $('.quantity', el);
      const max = parseInt(qtyInput.data('maxqty'), 10);
      let qty = parseInt(qtyInput.val(), 10);
      let debounce = null;

      const setQty = () => {
        qtyInput.val(qty);

        if (debounce) {
          clearTimeout(debounce);
          debounce = null;
        }

        debounce = setTimeout(() => {
          qtyInput.trigger('change');
        }, 500);
      };

      qtyInput.change((e) => {
        e.preventDefault();
      });

      incBtn.click((e) => {
        qty = (qty + 1 >= max) ? max : ++qty;
        if (qty === max) {
          $(incBtn).css('cursor', 'default');
        } else {
          $(incBtn).css('cursor', 'pointer');
        }
        $(decBtn).css('cursor', 'pointer');
        setQty();
      });

      decBtn.click((e) => {
        qty = (qty - 1 <= 1) ? 1 : --qty;
        if (qty === 1) {
          $(decBtn).css('cursor', 'default');
        } else {
          $(decBtn).css('cursor', 'pointer');
        }
        $(incBtn).css('cursor', 'pointer');
        setQty();
      });
    });
  }

  /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
     */
  validateBasket(data) {
    if (data.valid.error) {
      if (data.valid.message) {
        var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                    + 'fade show" role="alert">'
                    + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                    + '<span aria-hidden="true">&times;</span>'
                    + '</button>' + data.valid.message + '</div>';

        $('.cart-error').append(errorHtml);
      } else {
        $('.cart').empty().append('<div class="row"> '
                    + '<div class="col-12 text-center"> '
                    + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                    + '</div> '
                    + '</div>');
        $('.number-of-items').empty().append(data.resources.numberOfItems);
        $('.minicart-quantity').empty().append(data.numItems);
        $('.mini-cart .popover').empty();
        $('.mini-cart .popover').removeClass('show');
      }

      $('.checkout-btn').addClass('disabled');
    } else {
      $('.checkout-btn').removeClass('disabled');
    }
  }

  //re-render scalapay totals
  updateScalapayTotal(data) {
    var widget = $('scalapay-widget');
    if (widget.length > 0) {
      var widgetShadowRoot = document.querySelector('scalapay-widget').shadowRoot.getElementById('sp-container');
      var minPrice = $(widget).attr('min');
      var maxPrice = $(widget).attr('max');
      var grandTotal = Number((data.totals.grandTotal).replace(/[^0-9.-]+/g,""));

      $(widget).attr('amount', grandTotal);
      if (grandTotal >= minPrice && grandTotal <= maxPrice) {
        $(widget).show();
        widgetShadowRoot.style.display = 'block';
      } else {
        $(widget).hide();
      }
    }
  }

  /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
     */
  updateCartTotals(data) {
    $('.shipping-cost').removeClass('strike-through');
    $('.shipping-total-cost').removeClass('strike-through');
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    if (data.totals.totalShippingCostValue === 0) {
      $('.shipping-cost').empty().append($('.shipping-cost').attr('data-shipping-free'));
    } else {
      $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    }
    $('.tax-total').empty().append(data.totals.totalTax);
    $(
      '.grand-total .text-right span, .cart-summary-row .text-right strong, .cart-summary-row strong span'
    ).empty().append(data.totals.grandTotal);
    $('.shipping-subtotal').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);

    if (data.totals.orderLevelDiscountTotal.value > 0) {
      $('.order-discount').removeClass('hide-order-discount');
      $('.order-discount-total').empty().append('- ' + data.totals.orderLevelDiscountTotal
        .formatted);
    } else {
      $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
      $('.shipping-discount-total').empty().append('- ' + data.totals.shippingLevelDiscountTotal
        .formatted);
    } else {
      $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.totals.codTotalPrice) {
      $('.cod-item').removeClass('hide-cod-item');
      $('.cod-total-cost').empty().append(data.totals.codTotalPrice);
    } else {
      $('.cod-item').addClass('hide-cod-item');
    }
    let sales;
    data.items.forEach(function (item) {
      $('.item-' + item.UUID).empty().append(item.renderedPromotions);
      $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
      if (item.price.list !== null) {
        $('.full-price-' + item.UUID).removeClass('hidden');
        $('.full-price-' + item.UUID).empty().append(item.price.list.formatted);
      } else {
        $('.full-price-' + item.UUID).addClass('hidden');
      }
      sales = $('.sales-' + item.UUID);
      sales.empty().append(item.price.sales.formatted);
      if (item.outletData.isOutlet && (item.appliedPromotions === null || item.appliedPromotions.length === 0)) sales.hide();
      else sales.show();
    });
  }

  /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} message - Error message to display
     */
  createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
            + 'fade show" role="alert">'
            + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
            + '<span aria-hidden="true">&times;</span>'
            + '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
  }

  /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
     */
  updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
      approachingDiscounts.forEach(function (item) {
        html += '<div class="single-approaching-discount text-center">'
                    + item.discountMsg + '</div>';
      });
    }
    $('.approaching-discounts').append(html);
  }

  /**
     * Updates the availability of a product line item
     * @param {Object} data - AJAX response from the server
     * @param {string} uuid - The uuid of the product line item to update
     */
  updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i].UUID === uuid) {
        lineItem = data.items[i];
        break;
      }
    }

    var availability = $('.availability-' + lineItem.UUID);

    // TR-2156
    var tagName = availability.find('.line-item-attributes').prop('tagName').toLowerCase() || 'p';

    availability.empty();

    if (lineItem.availability) {
      if (lineItem.availability.messages) {
        lineItem.availability.messages.forEach(function (message) {
          messages += `<${tagName} class="line-item-attributes">${message}</${tagName}>`;
        });
      }

      if (lineItem.availability.inStockDate) {
        messages += `<${tagName} class="line-item-attributes line-item-instock-date">${lineItem.availability.inStockDate}</${tagName}>`;
      }
    }

    availability.html(messages);
  }

  uiCartStatusUpdate(url) {
    $.ajax({
      url: url,
      type: 'get',
      context: $('.quantity-form .quantity'),
      dataType: 'json',
      success: (data) => {
        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        this.updateCartTotals(data);
        this.updateScalapayTotal(data);
        this.updateApproachingDiscounts(data.approachingDiscounts);
        this.validateBasket(data);

        for(let i=0; i<data.items.length; i++){
          let item = data.items[i];
          let uuid = item.UUID
          let quantity = item.quantity

          let selector = $('.quantity[data-uuid="' + uuid + '"]')
          if(selector.length>0){
            selector.val(quantity);
            this.updateAvailability(data, uuid);
            selector.data('pre-select-qty', quantity);
          }else{
            location.reload()
          }
        }
      }
    });
  }
}

function handleShippingLabel(data) {
  var $labelBlock = $('#js-label-shipping');

  if (data.labelShipping && typeof data.labelShipping === 'string') {
    if ($labelBlock.length === 0) {
      const $container = $('<div>', {
        class: 'grid-container medium-down-full',
        id: 'js-label-shipping'
      });

      const $cell = $('<div>', { class: 'small-12 cell' }).appendTo($container);
      const $callout = $('<div>', { class: 'callout alert cart-callout' }).appendTo($cell);
      const $message = $('<div>', { class: 'callout-message' }).appendTo($callout);

      $message.html(data.labelShipping);

      $('#cart').before($container);
    } else {
      $labelBlock.find('.callout-message').html(data.labelShipping);
    }
  } else {
    if ($labelBlock.length > 0) {
      $labelBlock.remove();
    }
  }
}

const Cart = new cart();
window.Cart = Cart
Cart.run();



// WEBPACK FOOTER //
// ./assets/scripts/cart.js